import {
  Box,
  CircularProgress,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { SettingsPageText } from "../../data/texts";
import { Images } from "../../models/assets-files";
import { ImageService } from "../../services/image.service";
import { StyledSettingsScreen } from "../../styled-cmps/settings-screen";
import Image from "../common/Image";
import TextSwitch from "../common/TextSwitch";
import useScreen from "../common/UseScreen";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { StoreState } from "../../store/store";
import { UserService } from "../../services/user.service";
import { setUser } from "../../store/user.store";

interface Notifications {
  general: boolean;
  personal: boolean;
}

const NotificationsScreen = () => {
  const user = useSelector((state: StoreState) => state.user.loggedInUser);
  const dispatch = useDispatch();
  const theme = useTheme();
  const [isLoading, setIsLoading] = useState(false);
  const [notifications, setNotifications] = useState<Notifications>({
    general: !!user?.notificationsettings?.general,
    personal: !!user?.notificationsettings?.personal,
  });

  const onSwitch = async (cta: SettingsPageText) => {
    setIsLoading(true);
    if (!user?.id) return;
    switch (cta) {
      case SettingsPageText.GENERAL_UPDATES:
        await UserService.setNotificationSettings(
          user.id,
          notifications.general,
          notifications.personal
        );
        setNotifications({ ...notifications, general: !notifications.general });
        break;
      case SettingsPageText.PERSONAL_UPDATES:
        await UserService.setNotificationSettings(
          user.id,
          notifications.general,
          notifications.personal
        );
        setNotifications({
          ...notifications,
          personal: !notifications.personal,
        });
        break;
    }
  };

  useEffect(() => {
    setIsLoading(false);
    if (user) {
      dispatch(setUser({ ...user, notificationsettings: notifications }));
    }
  }, [notifications]);

  const { isDesktop } = useScreen();
  const imgBreakpoint = useMediaQuery("(min-width: 1000px)");
  return (
    <StyledSettingsScreen
      sx={{ ...(isLoading ? theme.customStyles.disabled : {}) }}
      flexDirection={isDesktop ? "row" : "column"}
    >
      {isLoading && (
        <CircularProgress
          sx={{ position: "absolute", left: "50%", top: "40%" }}
        />
      )}
      <Box sx={{ width: !isDesktop ? "100%" : "50%", marginBottom: "50px" }}>
        <Typography sx={{ fontWeight: "400", marginBottom: "20px" }}>
          {SettingsPageText.NOTIFICATIONS}
        </Typography>
        <Stack gap={"5px"}>
          <TextSwitch
            isEnabled={notifications.general}
            onSwitch={() => {
              onSwitch(SettingsPageText.GENERAL_UPDATES);
            }}
            text={SettingsPageText.GENERAL_UPDATES}
          />
          <Typography sx={{ marginBottom: "20px" }}>
            {SettingsPageText.GENERAL_UPDATES_DESCRIPTION}
          </Typography>
          <TextSwitch
            isEnabled={notifications.personal}
            onSwitch={() => {
              onSwitch(SettingsPageText.PERSONAL_UPDATES);
            }}
            text={SettingsPageText.PERSONAL_UPDATES}
          />
          <Typography>
            {SettingsPageText.PERSONAL_UPDATES_DESCRIPTION}
          </Typography>
        </Stack>
      </Box>
      <Image
        sx={{
          width: imgBreakpoint ? "300px" : "200px",
          objectFit: "contain",
          alignSelf: !isDesktop ? "center" : "unset",
        }}
        src={ImageService.getLocalImgPath(
          Images.Folders.SETTINGS,
          Images.Settings.PERSON_SCREENS,
          "png"
        )}
      />
    </StyledSettingsScreen>
  );
};

export default NotificationsScreen;
